import { writable } from 'svelte/store';

export type DeviceRuntimeDiagnosticEventType =
	| 'load:start'
	| 'load:complete'
	| 'load:error'
	| 'runtime:reset'
	| 'status:hydrate'
	| 'settings:hydrate'
	| 'status:flush'
	| 'settings:patch'
	| 'status:remove'
	| 'settings:remove';

export interface DeviceRuntimeDiagnosticEvent {
	id: number;
	timestamp: number;
	type: DeviceRuntimeDiagnosticEventType;
	generation?: number;
	durationMs?: number;
	details?: Record<string, string | number | boolean>;
}

const MAX_EVENTS = 200;
let nextEventId = 1;
let verboseCapture = false;

const { subscribe, set, update } = writable<DeviceRuntimeDiagnosticEvent[]>([]);

const record = (event: Omit<DeviceRuntimeDiagnosticEvent, 'id' | 'timestamp'>): void => {
	update((events) => {
		const next = [
			...events,
			{
				...event,
				id: nextEventId++,
				timestamp: Date.now(),
			},
		];
		return next.length > MAX_EVENTS ? next.slice(-MAX_EVENTS) : next;
	});
};

export const deviceRuntimeDiagnostics = {
	subscribe,
	record,
	recordVerbose(event: Omit<DeviceRuntimeDiagnosticEvent, 'id' | 'timestamp'>): void {
		if (verboseCapture) record(event);
	},
	setVerboseCapture(enabled: boolean): void {
		verboseCapture = enabled;
	},
	clear(): void {
		set([]);
	},
};
